import { render, staticRenderFns } from "./queue-list.vue?vue&type=template&id=06711305&scoped=true&"
import script from "./queue-list.vue?vue&type=script&lang=js&"
export * from "./queue-list.vue?vue&type=script&lang=js&"
import style0 from "./queue-list.vue?vue&type=style&index=0&id=06711305&scoped=true&lang=scss&"
import style1 from "./queue-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06711305",
  null
  
)

export default component.exports